// <div data-controller="file-dropzone">
//   <div data-file-dropzone-target="zone"
//        data-action="dragover->file-dropzone#dragOver dragleave->file-dropzone#dragLeave drop->file-dropzone#drop">
//     <label>
//       <span>Upload a file</span>
//       <input type="file" class="sr-only" data-file-dropzone-target="input" data-action="change->file-dropzone#update" />
//     </label>
//     <p data-file-dropzone-target="hint">PNG, JPG up to 10MB</p>
//   </div>
// </div>
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['zone', 'input', 'hint']

  connect() {
    this.defaultHint = this.hasHintTarget ? this.hintTarget.textContent : ''
  }

  dragOver(event) {
    event.preventDefault()
    this.zoneTarget.classList.add('border-red-600', 'bg-red-50')
  }

  dragLeave(event) {
    event.preventDefault()
    this.zoneTarget.classList.remove('border-red-600', 'bg-red-50')
  }

  drop(event) {
    event.preventDefault()
    this.zoneTarget.classList.remove('border-red-600', 'bg-red-50')
    if (event.dataTransfer.files.length) {
      this.inputTarget.files = event.dataTransfer.files
      this.update()
    }
  }

  update() {
    if (!this.hasHintTarget) return
    const names = Array.from(this.inputTarget.files).map((file) => file.name)
    this.hintTarget.textContent = names.length ? names.join(', ') : this.defaultHint
  }
}
